export default __webpack_public_path__ + "static/media/they-are-the-best.833e1cbc.mp3";